import React, { useState, useEffect } from 'react'
import { Col, Row } from 'react-bootstrap'
import { useSelector } from "react-redux";
import { useTranslation } from "../../hooks/useTranslation";
import { useForm } from "react-hook-form";
import apiService from "../../services/api.service";
import { useDispatch } from "react-redux";
import { setCompany } from "../../Redux/companyReducer";
import { showToast } from "../../Redux/toastReducer";

function CompanyDetailsForm({ readOnly = true }) {
      const {
        register,
        handleSubmit,
        setValue,
        watch,
        trigger,
        formState: { errors },
      } = useForm({
        mode: "onChange",
        reValidateMode: "onChange",
        shouldFocusError: true,
        shouldUnregister: false,
        shouldUseNativeValidation: false,
      });
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const company = useSelector((state) => state.company.company);

    useEffect(() => {
        //fillInAllFields company fields
        setValue("CompanyNameInput", company?.companyName || "", { shouldDirty: true });
        setValue("CompanyVatNumberInput", company?.companyVatNumber || "", { shouldDirty: true });
        setValue("CompanyAddressInput", company?.companyAddress || "", { shouldDirty: true });
        setValue("CompanyCityInput", company?.companyCity || "", { shouldDirty: true });
    }, []);

    const submitForm = (data) => {

    let valid = true;
    let errorMsg = "";

    if (!valid) {
      errorMsg = t("CheckAllFields");
      alert(errorMsg);
    }
    else {
      apiService
                .setCompany({
                    companyId: company.companyId, 
                    companyName: data.CompanyVatNumberInput, 
                    companyVatNumber: data.CompanyVatNumberInput,
                    companyAddress: data.companyAddress,
                    companyCity: data.companyCity,
                })
                .then((res) => {
                  if (res.data && !res.HasErrors) {
                    dispatch(setCompany({
                      ...company,
                      companyName: data.CompanyNameInput,
                      companyVatNumber: data.CompanyVatNumberInput
                    }))
                    dispatch(showToast({ message: t("CompanyDetailsUpdateSuccess"), severity: "success" }));
                  }
                  else {
                    dispatch(showToast({ message: t("CompanyDetailsUpdateFailure"), severity: "error" }));
                  }
                })
                .catch((err) => {
                  console.error(err);
                });
    }
  };

    return (
        <div id="companyDtlTab" className="account-section hidden">
            <h4>{t("CompanyDetails")}</h4>
            <form onSubmit={handleSubmit((data) => submitForm(data))}>
                <div className="personal-details-form-wrap box">
                    <div>
                        <Row>
                            <Col xs="12" md="4">
                                        <label htmlFor="CompanyNameInput">{t("CompanyNameInput")}</label>
                                        <input
                                            name="CompanyNameInput"
                                            {...register("CompanyNameInput", {
                                                required: t("Required"),
                                                disabled: readOnly,
                                            })}
                                        />
                                        <span className="error">{errors.CompanyNameInput?.message}</span>
                                    </Col>
                                    <Col xs="12" md="4">
                                        <label htmlFor="CompanyVatNumberInput">{t("CompanyVatNumberInput")}</label>
                                        <input
                                            name="CompanyVatNumberInput"
                                            {...register("CompanyVatNumberInput", {
                                                required: t("Required"),
                                                disabled: readOnly,
                                            })}
                                        />
                                        <span className="error">{errors.CompanyVatNumberInput?.message}</span>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs="12" md="4">
                                        <label htmlFor="CompanyCityInput">{t("CompanyCityInput")}</label>
                                        <input
                                            name="CompanyCityInput"
                                            {...register("CompanyCityInput", {
                                                required: t("Required"),
                                                disabled: readOnly,
                                            })}
                                        />
                                        <span className="error">{errors.CompanyCityInput?.message}</span>
                                    </Col>
                                    <Col xs="12" md="4">
                                        <label htmlFor="CompanyAddressInput">{t("CompanyAddressInput")}</label>
                                        <input
                                            name="CompanyAddressInput"
                                            {...register("CompanyAddressInput", {
                                                required: t("Required"),
                                                disabled: readOnly,
                                            })}
                                        />
                                        <span className="error">{errors.CompanyAddressInput?.message}</span>
                                    </Col>
                        </Row>
                        {
                            false && // company can only see deatils
                            <Row>
                                <Col xs="12" md="4">
                                    <button
                                        type="submit"
                                        className="btn personal-details-btn"
                                    >{t("UpdateDetails")}</button>
                                </Col>
                            </Row>
                        }


                    </div>
                </div>
            </form>

        </div>)
}

export default CompanyDetailsForm